import { AbstractAnimationVO } from "./AbstractAnimationVO";

import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import Container = createjs.Container;

export class GetXPAnimationVO extends AbstractAnimationVO {
    public xpAmount: string;
    public playerContainer: MovieClip;
    public menuPanel: DisplayObject;
    public animationContainer: Container;

    constructor(xpAmount: string, playerContainer: MovieClip, menuPanel: DisplayObject, animationContainer: Container) {
        super();
        this.xpAmount = xpAmount;
        this.playerContainer = playerContainer;
        this.menuPanel = menuPanel;
        this.animationContainer = animationContainer;
    }
}
